import React from "react";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";
import { ProductImageRenditions } from "@utils/enums";

import { BreakpointMinSizes } from "@services/breakpoint.service";

import { ProductImage } from "@components/Product/ProductImage/imageWrapper/imageWrapper.component";

import { Renditions } from "./mappedRenditions";
import { Media } from "lib/@types/service/shared";

type Props = {
    title: string | undefined;
    medias: null | Array<Media>;
    isEcoChequesAccepted: boolean;
    renditions?: Renditions;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImageWrapper = ({
    title,
    medias,
    isEcoChequesAccepted,
    renditions,
    className,
    lazyLoad = false,
    parentFit = false,
}: Props) => {
    const { breakpoints } = useBreakpoint();

    const activeRendition = (Object.keys(breakpoints) as BreakpointMinSizes[])
        .reverse()
        .find(k => breakpoints[k]);

    const rendition = activeRendition
        ? renditions && renditions[activeRendition]
        : (renditions && renditions.defaultRendition) ||
          ProductImageRenditions.SM;

    return (
        <ProductImage
            title={title}
            medias={medias}
            isEcoChequesAccepted={isEcoChequesAccepted}
            rendition={rendition}
            className={className}
            lazyLoad={lazyLoad}
            parentFit={parentFit}
        />
    );
};

export { ProductImageWrapper };
